import React from "react";

import { Button } from "../../../components/Field";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";

import style from "./style.module.css";

export default function Subscribe(props) {
	const { 
		subscribe_title = "", 
		subscribe_text = "", 
		subscribe_button_label = "", 
		subscribe_button_url = "" 
	} = props;

	if(subscribe_title?.trim() && subscribe_text?.trim()){
		return (
			<Section className={style.subscribe}>
				<div className={style.subscribePage}>
					<div className={style.subscribePageText}>
						<div className={style.newsLetterContent}>
							{
								subscribe_title !== "" && (
									<Title 
										transform="uppercase" 
										tag="h3" 
										className="fontTeko"
									>
										{subscribe_title}
									</Title>
								)
							}
							{
								subscribe_text !== "" && (
									<Editor text={subscribe_text} />
								)
							}
						</div>
						{
							subscribe_button_label !== "" && subscribe_button_url !== "" && (
								<div className={style.newsLetterButton}>
									<Button label={subscribe_button_label} link={subscribe_button_url} />
								</div>
							)
						}
					</div>
				</div>
			</Section>
		)
	}
	return null;
}